import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { ORDER_STATUS } from "common/utils/consts";

interface IFinishedOrderModerationState {
  activeOrderId?: number;
  finishedOrderDateFrom?: string;
  finishedOrderDateTo?: string;
  finishedOrderStatus: number;
}

const initialState: IFinishedOrderModerationState = {
  finishedOrderStatus: ORDER_STATUS.ON_REVIEW,
};

const finishedOrderModerationSlice = createSlice({
  name: "finishedOrderModeration",
  initialState,
  reducers: {
    setAvtiveOrderId(state, action: PayloadAction<Undefinable<number>>) {
      if (state.activeOrderId === action.payload) {
        state.activeOrderId = undefined;
      } else state.activeOrderId = action.payload;
    },
    setDateFrom(state, action: PayloadAction<Undefinable<string>>) {
      state.finishedOrderDateFrom = action.payload;
    },
    setDateTo(state, action: PayloadAction<Undefinable<string>>) {
      state.finishedOrderDateTo = action.payload;
    },
    setFinishedOrderStatus(state, action: PayloadAction<number>) {
      state.finishedOrderStatus = action.payload;
      state.activeOrderId = undefined;
    },
  },
});

export const {
  setAvtiveOrderId,
  setDateFrom,
  setDateTo,
  setFinishedOrderStatus,
} = finishedOrderModerationSlice.actions;

export const finishedOrderModerationReducer =
  finishedOrderModerationSlice.reducer;
